import React from 'react';
import { TextField } from '@mui/material';

const DebounceFilter = ({
  handleDebounceFilter,
}) => (
  <TextField
    type="search"
    placeholder="Filter"
    size="small"
    fullWidth
    onClick={(e) => e.stopPropagation()}
    onChange={(e) => {
      handleDebounceFilter(e);
    }}
    sx={{ m: 0.5 }}
  />
);

export default DebounceFilter;
